import { motion } from "framer-motion";
import { SectionHeading, fadeUp } from "@/components/landing/shared";
import { useSiteContent } from "@/context/ContentContext";

export default function ProcessSection() {
  const { process } = useSiteContent();
  const steps = process.steps || [];
  return (
    <section
      id="processo"
      className="relative scroll-mt-20 border-t border-black/[0.08] py-16 md:py-24 lg:py-28"
    >
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={process.eyebrow}
          title={process.title}
          intro={process.intro}
        />

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-black/10 bg-black/[0.03] sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <motion.div
              key={`${s.n}-${i}`}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-30px" }}
              variants={fadeUp}
              custom={i % 4}
              className="group relative bg-[var(--ink-900)] p-6"
            >
              <span className="font-mono-tech text-2xl font-medium text-emerald-700/70 tabnum">
                {s.n}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-[color:var(--text-primary)]">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-secondary">
                {s.body}
              </p>
              <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-emerald-400 transition-all duration-500 group-hover:w-full" />
            </motion.div>
          ))}
          <div className="hidden bg-[var(--ink-900)] lg:block" />
        </div>
      </div>
    </section>
  );
}
